module.exports = __webpack_public_path__ + "static/media/undp.71beccd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/undp.png
// module id = 998
// module chunks = 0